import { Dispatch, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { GenericObject, PurchaseData, datosCompra, eventoSeleccionado, sectorList } from '../../../types/types';
import { Row, Col, Button, Modal, ModalHeader, ModalBody, Input, ModalFooter } from 'reactstrap';
import { fetchDetalleCompra } from '../../../reducer/events-reducer';
import { getPrices, purchaseSell } from '../../../api/purchase';
import { Table } from 'antd';
import '../../sass/evento_seleccionado.scss'
import DetalleCompra from './DetalleCompra';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { mostrarError } from '../../../reducer/config-reducer';
export type configObjectEventos = {
    eventsReducer: {
        datosCompraPasoDos: PurchaseData;
        detalleCompra: datosCompra;
        eventoSeleccionado: eventoSeleccionado;
    };
};

/** Id de precio desde API: evita tratar 0 u otros valores falsy como "sin id". */
const priceIdFromApi = (id: unknown): string | null =>
    id === null || id === undefined || id === '' ? null : String(id);

/** Mensajes de error al buscar los precios de un sector. */
const ERROR_PRECIOS_MESSAGE = 'No pudimos obtener los precios de este sector. Por favor, intenta nuevamente.';
const SIN_PRECIOS_MESSAGE = 'Este sector no tiene precios disponibles en este momento.';

const CompraEventoPlural = ({
    datosCompraPasoDos,
    fetchDetalleCompra,
    detalleCompra,
    mostrarError,
    eventoSeleccionado
}: {
    datosCompraPasoDos: PurchaseData;
    fetchDetalleCompra: () => any;
    detalleCompra: datosCompra;
    mostrarError:Dispatch<GenericObject | null>;
    eventoSeleccionado: eventoSeleccionado;
}) => {
    const [modal, setModal] = useState<boolean>(false);
    const [selectedListItem, setSelectedListItem] = useState<sectorList | null>(null);
    const [selectedPriceIndex, setSelectedPriceIndex] = useState<number | null>(0);
    const [selectedPriceId, setSelectedPriceId] = useState<string | null>(null);
    const [disableBt, setdisableBt] = useState(false);
    const [errorMessage, seterrorMessage] = useState<string | undefined>();
    const [errorModal, setErrorModal] = useState<boolean>(false);

    const columns = [
        {
            title: '',
            dataIndex: 'radio',
            key: 'radio',
            render: (_: any, record: any) => (
                <Input
                    type="radio"
                    name="price-type-plural"
                    checked={selectedPriceId != null ? record.id === selectedPriceId : record.key === selectedPriceIndex}
                    onChange={() => handlePriceSelection(record.key, record.id)}
                />
            ),
        },
        {
            title: 'Label',
            dataIndex: 'label',
            key: 'label',
        },
        {
            title: 'Price',
            dataIndex: 'price',
            key: 'price',
        },
    ];

    const addPlacesText = (returnTextType: 'message' | 'info') => {
        let itemSale = JSON.parse(eventoSeleccionado.itemSale);
        //si existe word_form, se usa para determinar si el item es singular o plural
        let placesText = '';
        if(itemSale.word_form && itemSale.word_form === 'singular') {
            if(returnTextType === 'message') {
                placesText = `${itemSale.item_paso_2_singular} Disponibles`;    
            } else {
                placesText = `Toca el Sector para agregar tu ${itemSale.item_paso_2_singular}.`;
            }
        } else {
            if(returnTextType === 'message') {
                placesText = `${itemSale.item_paso_2} Disponibles`;
            } else {
                placesText = `Toca el Sector y repite tantas veces como ${itemSale.item_paso_2} a agregar.`;
            }
        }
        return placesText;
    }

    const toggle = () => {
        setModal(!modal);
        if (modal) {
            setSelectedPriceIndex(0);
            setSelectedPriceId(null);
            setdisableBt(false);
        }
    };

    const toggleErrorModal = () => {
        setErrorModal(!errorModal);
    }

    /** Muestra el modal de aviso con el mensaje recibido (o uno generico si no vino ninguno). */
    const showErrorModal = (message?: string) => {
        seterrorMessage(message && String(message).trim() !== '' ? String(message) : ERROR_PRECIOS_MESSAGE);
        setErrorModal(true);
    }

    const handlePriceSelection = (index: number, id: string | null) => {
        setSelectedPriceIndex(index);
        setSelectedPriceId(id);
        setdisableBt(false);
    };

    const handleSector = async (sector: sectorList) => {
        try {
            const response = await getPrices(sector.code);

            if (response.result === true) {
                const prices = response.prices;
                if (!Array.isArray(prices) || prices.length === 0) {
                    showErrorModal(SIN_PRECIOS_MESSAGE);
                    return;
                }
                // Crear una copia inmutable del sector con los precios
                const sectorWithPrices = {
                    ...sector,
                    prices
                };
                const first = prices[0];
                const initialPriceId = priceIdFromApi(first?.id);
                setSelectedPriceIndex(0);
                setSelectedPriceId(initialPriceId);
                toggle();
                setSelectedListItem(sectorWithPrices);
            } else {
                showErrorModal(response?.message);
            }
        } catch (error: any) {
            showErrorModal(error?.response?.data?.message ?? error?.message);
        }
    }

    const handleAceptarButton = async () => {
        if (selectedPriceIndex !== null || selectedPriceId !== null) {
            setdisableBt(true);
            const prices = selectedListItem!.prices;
            const idx = selectedPriceIndex;
            const priceIdToSend =
                selectedPriceId != null
                    ? selectedPriceId
                    : idx != null
                      ? priceIdFromApi(prices[idx]?.id) ?? undefined
                      : undefined;
            const res = await purchaseSell(
                selectedListItem!.code,
                selectedPriceIndex != null ? selectedPriceIndex : undefined,
                priceIdToSend != null ? priceIdToSend : undefined
            );
            if (res.result === true) {
                await fetchDetalleCompra();
                setSelectedPriceIndex(null);
                setSelectedPriceId(null);
                setdisableBt(false);
                toggle();
            } else {
                let message = res.message;
                if (message.includes('NO_ACEPTA_MAS_VENTAS')) {
                    message = `No hay más ${addPlacesText('message')}`;
                }

                seterrorMessage(message);
                toggle();
                toggleErrorModal();
            }
        }
    };

    useEffect(() => {
        fetchDetalleCompra();


    }, [fetchDetalleCompra]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const dataSource = selectedListItem
        ? selectedListItem.prices.map((precio, index) => ({
            key: index,
            id: priceIdFromApi(precio.id),
            radio: <Input type="radio" name='radio' />,
            label: precio.label,
            price: precio.price,
        }))
        : [];

    /** Si el backend no envia el campo, se asume que el sector no esta agotado. */
    const isSoldout = (sector: sectorList) => sector.soldout === true;

    /** Mantiene el orden recibido, pero envia los sectores agotados al final. */
    const orderedSectorList = [...datosCompraPasoDos.sectorList].sort(
        (a, b) => Number(isSoldout(a)) - Number(isSoldout(b))
    );

    return (
        <>
            <Modal isOpen={errorModal} toggle={toggleErrorModal} centered={true}>
                <ModalHeader toggle={toggleErrorModal}>AVISO</ModalHeader>
                <ModalBody className='error-handler'>
                    <p className='text-center error-message'>{errorMessage}</p>
                    <div className='d-flext justify-content-center p-0 mb-2'>
                        <Row className='text-center'>
                            <Col md={12} className='pb-2 pt-2'>
                                <Button className='cancel-bt ps-5 pe-5' onClick={()=>{ toggleErrorModal(); }}>CERRAR </Button>
                            </Col>
                        </Row>
                    </div>
                </ModalBody>
            </Modal>
            <Modal isOpen={modal} toggle={toggle} centered={true} className='modal-compra-evento-plural' backdrop='static'>
                <ModalHeader toggle={toggle}>ESTAS AGREGANDO UN<br /> ITEM A TU COMPRA</ModalHeader>
                {selectedListItem && (
                    <>
                        <ModalBody className='pb-0'>
                                <Col>
                                    <h5 className="text-center">{selectedListItem.name}</h5>
                                </Col>
                                <Col className='mt-3 mb-3'>
                                    <p className='text-center'>Selecciona Tipo de Precio:</p>
                                    <Table columns={columns} dataSource={dataSource} pagination={false} showHeader={false} />
                                </Col>
                        </ModalBody>
                        <ModalFooter className='d-flext justify-content-center p-0 mb-2'>
                            {/*<Button className='cancel-bt' onClick={()=>{ toggle(); setSelectedPriceIndex(null) }}>CANCELAR <CloseIcon /></Button>*/}
                            <Button disabled={disableBt} onClick={handleAceptarButton}>ACEPTAR <ArrowForwardIosIcon /></Button>
                        </ModalFooter>
                    </>
                )}
            </Modal>
            <div>
                <p className='compra-paso2-info-text'>{addPlacesText('info')}</p>
                <div className='button-wrapper-tipo-plural'>{orderedSectorList.map((sector, index) => {
                    if (isSoldout(sector)) {
                        return (
                            <div className='sector-soldout-wrapper mb-2' key={index}>
                                <Button className='compra-plural-bt sector-soldout' disabled>
                                    {sector.name}
                                </Button>
                                <span className='badge badge-soldout'>AGOTADO</span>
                            </div>
                        );
                    }
                    if (sector.enable) {
                        return (
                            <Button className='compra-plural-bt mb-2' key={index} onClick={() => {
                                handleSector(sector)
                            }}>
                                {sector.name}
                            </Button>
                        );
                    }
                })}</div>

                <Row className="mt-4 mb-4">
                    <Col>

                        {detalleCompra && <DetalleCompra />}
                    </Col>
                </Row>
            </div>
        </>
    );
};

const mapStateToProps = (state: configObjectEventos) => {
    return {
        datosCompraPasoDos: state.eventsReducer.datosCompraPasoDos,
        detalleCompra: state.eventsReducer.detalleCompra,
        eventoSeleccionado: state.eventsReducer.eventoSeleccionado,
    };
};

export default connect(
    mapStateToProps,
    { fetchDetalleCompra, mostrarError }
)(CompraEventoPlural);